import { List, Modal, Text } from "@mantine/core";

import type { ImportError } from "./CheckListImport.utils";

interface Props {
  opened: boolean;
  onClose: () => void;
  errors: ImportError[];
}

const ImportErrorsModal = ({ opened, onClose, errors }: Props) => (
  <Modal opened={opened} onClose={onClose} title="Import errors" size="lg">
    <Text size="sm" mb="sm">
      This file couldn&apos;t be imported. Fix the following in your
      spreadsheet and re-upload:
    </Text>
    <List size="sm" spacing="xs">
      {errors.map((error, index) => (
        <List.Item key={index}>{error.message}</List.Item>
      ))}
    </List>
  </Modal>
);

export default ImportErrorsModal;
